import React, { useEffect } from "react";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Resolver, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import { ClientSchema } from "../../_App/Schemas/ClientSchema";
import ClientType, {
  NiveauFideliteType,
} from "../../_App/Types/Entites/ClientType";
import {
  createNIveauFidApi,
  ListNiveauxFidelite,
  updateNIveauFidApi,
} from "../../_App/Redux/Slices/client/clientSlice";
import {
  SelectedOrganisationId,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import { useTranslation } from "react-i18next";
import { NiveauFidSchema } from "../../_App/Schemas/NIveauFidSchema";

export default function NiveauClientForm({
  ShowModal,
  setShowModal,
  client,
  verifcationMsg,
}: any) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const societe = useAppSelector(societeId);
  const organisation = useAppSelector(SelectedOrganisationId);

  // init form hooks
  const formOptions = {
    resolver: yupResolver(
      NiveauFidSchema,
    ) as unknown as Resolver<NiveauFideliteType>,
  };
  const { register, handleSubmit, reset, formState } =
    useForm<NiveauFideliteType>(formOptions);
  const { errors } = formState;

  useEffect(() => {
    if (client) {
      reset({
        _id: client._id,
        libelle: client.libelle,
        organisation_id: client.organisation_id,
        pointsMin: client.pointsMin,
        societe_id: client.societe_id,
      });
    } else {
      reset({
        libelle: "",
        societe_id: societe,
        pointsMin: 0,
        organisation_id: organisation,
      });
    }
  }, [client, ShowModal]);

  const onSubmit = async (data: any) => {
    let response;
    console.log("Submitted data:", data); // Add this
    data.default = false;

    if (data._id) {
      if (await verifcationMsg(t("vous voulez modifier le client")))
        response = await dispatch(updateNIveauFidApi(data));
    } else {
      response = await dispatch(createNIveauFidApi(data));
    }
    if (response) {
      if (response.payload.success) {
        ToastSuccess(t(response.payload.message));
        reset({
          libelle: "",
          societe_id: societe,
          pointsMin: 0,
        });
        setShowModal(false);
      } else {
        ToastWarning(t(response.payload.message));
      }
    }
  };
  return (
    <Modal
      show={ShowModal}
      onHide={() => setShowModal(false)}
      className="modal-1"
      dialogClassName="modal-50w"
      backdropClassName="modal-backdrop-1"
    >
      <Modal.Header>
        <Modal.Title className="c-primary">
          {" "}
          {t("Nouvelle catégorie client")}
        </Modal.Title>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true" onClick={() => setShowModal(false)}>
            &times;
          </span>
        </button>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <label htmlFor="libelle">
                  <span style={{ color: "red" }}>*</span> {t("Libellé")}
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.libelle ? "is-invalid" : ""
                  }`}
                  id="libelle"
                  {...register("libelle")}
                />
                <div className="invalid-feedback">
                  {errors.libelle?.message?.toString()}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="reset" className="btn btn-primary-app">
            {t("Annuler")}
          </Button>
          <Button type="submit" className="btn btn-primary-app">
            {t("Enregistrer")}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
